import script from "./TheoDoiHopDongPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheoDoiHopDongPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./TheoDoiHopDongPrintModal.vue?vue&type=style&index=0&id=4679d40c&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4679d40c"]])

export default __exports__